var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileField',{attrs:{"id":"email","label":"Primary Email","value":_vm.value,"error":_vm.errors.get('email'),"type":"email"},on:{"input":email => _vm.$emit('input', email)}})
}
var staticRenderFns = []

export { render, staticRenderFns }